import GiftCard from "./giftcard";

export default GiftCard;
